<template>
<div class="chapter">
<div class="inner_page">
<a id="page_ii"></a>
<p class="center"><em class="italic">Dedication</em></p>
<p class="center1"><em class="italic">This book is dedicated to Major Masao Horie, Imperial Japanese Army</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Dedication.vue?5007667e